<template>
    <ModalContainer :visible="visible" :loading="loading" :is-large="true">
        <template v-slot:header>
            <button type="button" class="close"  @click="$emit('close-active-subscriptions')"><i class="las la-times"></i></button>
            <h4 v-if="subscriptionList.length > 0"  style="text-transform: capitalize;" class="modal-title"> {{subscriptionList[0].type.name}} - {{ $t('components.subscription.active_subscribers') }}</h4>
        </template>
        <template v-slot:body>
            <div class="table-responsive">
                <SubscriptionsActiveTable :subscriptions="subscriptionList"></SubscriptionsActiveTable>
            </div>
            <div class="text-center">
                <Pagination
                    v-show="numberPagesSubscriptionsActive > 1"
                    :page-count="numberPagesSubscriptionsActive"
                    :click-handler="paginateCallback" />
            </div>
        </template>

        <template v-slot:footer>
            <a class="btn btn-primary btn-block btn-lg" href="" @click.prevent.stop="$emit('close-active-subscriptions')">
                {{ $t('common.close') }}
            </a>
        </template>
    </ModalContainer>
</template>

<script>
    import {Utils} from "../../common/utils";
    import ModalContainer from "./ModalContainer";
    import {getSubscriptionsActive} from "@/api";
    import SubscriptionsActiveTable from "@/components/subscription/SubscriptionsActiveTable";
    import Pagination from "@/components/common/Pagination";
    import {LIMIT_RECORDS_API} from "@/common/constants";

    export default {
        name: "ActiveSubscriptionsModal",
        components: {ModalContainer, SubscriptionsActiveTable, Pagination},
        props: {
            visible: {
                type: Boolean,
                required: true
            },
            subscriptionTypeId: {
                type: Number,
                required: true
            }
        },
        computed: {
            numberPagesSubscriptionsActive: function () {
                return Utils.getNumberPageByCountLimit(this.countSubscriptionsActive, this.limitSubscriptionsActive);
            }
        },
        data: () => {
            return {
                loading: false,
                errorMessage: "",
                subscriptionList: [],
                countSubscriptionsActive: 0,
                limitSubscriptionsActive: LIMIT_RECORDS_API,
                currentPageSubscriptionActive: 1,
            }
        },
        watch: {
            async subscriptionTypeId(newVal) {
                await this.getSubscriptionsActiveData(1, newVal)
            }
        },
        methods: {
            paginateCallback(pageNum) {
                this.getSubscriptionsActiveData(pageNum, this.subscriptionTypeId)
            },
            async getSubscriptionsActiveData(page, subscriptionTypeId) {
                this.loading = true;
                try {
                    let response = await getSubscriptionsActive(page, subscriptionTypeId);
                    this.subscriptionList = response.results;
                    this.countSubscriptionsActive = response.count;
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            },
            getLongDateFromISO(date){
                return Utils.getLongDateFromISO(date)
            }
        }
    }
</script>

<style scoped>

</style>